import { ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type ParamsDTO = {
  uuids: string[]
  updateBody: {
    supplier_id: number
  }
}

export const useSnvUpdateMutation = () =>
  useMutation<unknown, ErrorDTO, ParamsDTO>({
    mutationFn: async (values: ParamsDTO) => {
      try {
        for (const uuid of values.uuids) {
          await client.put(
            `/supplier_name_variant/update/${uuid}`,
            values.updateBody
          )
        }

        toast.success('Supplier updated for selected name variants')
        return 'success'
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
